import { defineComponent, createElementBlock, openBlock, normalizeClass, unref, renderSlot } from "vue";
import { cn } from "../../../../lib/utils.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "AlertDialogFooter",
  props: {
    class: {}
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(unref(cn)("flex flex-col-reverse gap-2 sm:flex-row sm:justify-end", props.class)),
      "data-slot": "alert-dialog-footer"
    }, [
      renderSlot(_ctx.$slots, "default")
    ], 2));
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=AlertDialogFooter.js.map
